module.exports = __webpack_public_path__ + "img/paciente.7100f927.png";